var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Portal',{attrs:{"to":"loading","disabled":!_vm.full}},[_c('div',{staticClass:"loading-indicator",class:{ inline: _vm.inline, full: _vm.full }},[_c('BallPulseSync',{attrs:{"color":"#039be5"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }